<template>
  <transition name="no-mode-fade">
    <div class="tab-pane fade show active" id="addBadge" role="tabpanel">
      <b-row>
        <b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.title") }}</label>
            <input type="text" class="form-control" v-model="newItem.title" />
          </div> </b-col
        ><b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.type") }}</label>
            <div class="demo-inline-spacing">
              <b-form-radio v-model="newItem.type" name="type" value="text">
                {{ $t("announcements.text") }}
              </b-form-radio>
              <b-form-radio v-model="newItem.type" name="type" value="sound">
                {{ $t("announcements.sound") }}
              </b-form-radio>
            </div>
          </div>
        </b-col>
        <b-col lg="12">
          <div class="form-group" v-show="newItem.type == 'text'">
            <label>{{ $t("announcements.content") }}</label>
            <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}"  v-model="newItem.content" />
          </div>
          <div class="form-group" v-show="newItem.type == 'sound'">
            <label>{{ $t("announcements.sound") }}</label>
            <input
              accept="audio/*"
              @change="onChangeSound($event, 'sound')"
              type="file"
              class="form-control"
            />
          </div> </b-col
        ><b-col lg="6">
          <div class="form-group" v-if="user.account_type == 'admin'">
            <label>{{ $t("announcements.target") }}</label>

            <b-form-select
              v-model="newItem.target"
              :options="targetOptions"
              @input="selectTarget()"
            />
          </div>
        </b-col>
        <b-col lg="6" v-if="newItem.target == 'specific_master_student'">
          <div class="form-group">
            <label>{{ $t("students.students") }}</label>

            <b-form-select
              :options="users"
              text-field="full_name"
              value-field="id"
              v-model="newItem.student_id"
            />
          </div>
        </b-col>
        <b-col
          lg="6"
          v-if="
            newItem.target == 'specific_master_teacher' ||
            newItem.target == 'all_teachers_in_master'
          "
        >
          <div class="form-group">
            <label>{{ $t("teachers.teachers") }}</label>

            <b-form-select
              v-model="newItem.teacher_id"
              :options="users"
              text-field="full_name"
              value-field="id"
            />
          </div>
        </b-col>
        <b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.priority") }}</label>
            <div class="demo-inline-spacing">
              <b-form-radio
                v-model="newItem.priority"
                name="some-radios"
                value="1"
              >
                {{ $t("announcements.priority_high") }}
              </b-form-radio>
              <b-form-radio
                v-model="newItem.priority"
                name="some-radios"
                value="2"
              >
                {{ $t("announcements.priority_medium") }}
              </b-form-radio>
              <b-form-radio
                v-model="newItem.priority"
                name="some-radios"
                value="3"
              >
                {{ $t("announcements.priority_low") }}
              </b-form-radio>
            </div>
          </div>
        </b-col>
        <b-col lg="3">
          <div class="form-group">
            <label>{{ $t("announcements.badge") }}</label>
            <input
              @change="onChangeSound($event, 'badge')"
              type="file"
              class="form-control"
            />
          </div>
        </b-col>
        <b-col lg="3">
          <img style="width: 10vw; height: 10vw" v-if="url" :src="url" />
          <img
            style="width: 10vw; height: 10vw"
            v-if="!url"
            :src="newItem.image"
          />
        </b-col>
        <b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.publish_date") }}</label>
            <b-datepicker v-model="newItem.publish_date"></b-datepicker>
          </div>
        </b-col>
        <b-col lg="6">
          <div class="form-group">
            <label>{{ $t("announcements.expiry_date") }}</label>
            <b-datepicker v-model="newItem.expiry_date"></b-datepicker>
          </div>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="6">
          <b-button
            block
            :disabled="invalid"
            variant="primary"
            @click="submit()"
          >
            <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
          >
        </b-col>
        <b-col lg="6">
          <b-button block  @click="goToTable()"  variant="success">
            <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
          >
        </b-col>
      </b-row>
    </div>
  </transition>
</template>

<script>
import controller from "../../../../Controllers/MasterAnnouncementsController";
import config from "../../../../config/config";
import Auth from "@/Apis/Auth";
import EduProgramsController from "@/Controllers/EduProgramsController";
import UsersController from "@/Controllers/UsersController";
export default {
  props: ["newItem"],
  data() {
    return {
      url: null,
      targetOptions: [
        {
          value: "all_master_students",
          text: this.$i18n.t("master.all_master_students"),
        },
        {
          value: "specific_master_student",
          text: this.$i18n.t("master.specific_master_student"),
        },
        {
          value: "all_masters_teachers",
          text: this.$i18n.t("master.all_masters_teachers"),
        },
        {
          value: "specific_master_teacher",
          text: this.$i18n.t("master.specific_master_teacher"),
        },
        {
          value: "all_teachers_in_master",
          text: this.$i18n.t("master.all_teachers_in_master"),
        },
      ],

      contentBox: true,
      file: {},
      sound: "",
      
      user: {},
      eduPrograms: [],
      eduProgramId: 0,
      rooms: [],
      users: [],
    };
  },

  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      if (this.user.account_type == "teacher") {
        if (this.newItem.target == "all_students_in_edu_program") {
          this.newItem.edu_program_id = localStorage.getItem("eduProgram");
        } else if (this.newItem.target == "room_id") {
          this.newItem.room_id = localStorage.getItem("room");
        }
      }
      this.newItem.master = 1;
      let ret = await new controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },

    onChangeSound(e, field) {
      let _file = e.target.files[0];
      this.newItem[field] = _file;
      this.url = URL.createObjectURL(this.newItem[field]);
    },
    async selectTarget() {
      var type = "";
      if (this.newItem.target == "all_master_students") type = "student";
      if (
        this.newItem.target == "specific_master_teacher" ||
        this.newItem.target == "all_teachers_in_master"
      )
        type = "student";
      this.users = await new UsersController().GetAll({ type });
    },
  },
  created() {
    this.user = Auth.USER;
  },
  watch: {},
};
</script>

<style></style>